module.exports = __webpack_public_path__ + "static/img/training_system_s4_max.2ba42a66.png";